export default __webpack_public_path__ + "static/A5-1f815de81a1f862e06963aa426cc620d.png";